<template>
    <app-main>
        <app-header slot="header" color="is-default" :is_display_down="is_display_down"></app-header>
        <div class="imgBox">
            <img class="arrow" src="../assets/images/livePartner/lp.png">
            <img class="back" src="../assets/images/livePartner/lpb.jpg">
            <div class="button" @click="consult"></div>
        </div>
    </app-main>
</template>

<script>
    import {goNativeRoute, setStatusTextColor} from '../RNApp/index'
    import AppMain from './layouts/Main';
    import AppHeader from './layouts/Header';
    export default {
        name: "LivePartner",
        components: {
            AppMain, AppHeader
        },
        data() {
            return {
                is_display_down:false,
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.setStatus();
            });
        },
        methods: {
            setStatus() {
                if (this.$route.query.inApp == 6) {
                    setStatusTextColor("black");
                }
            },
            consult () {
                const data = {
                    url: 'jadeking://MessageSessionDetail?accid=jaadee456'
                }
                goNativeRoute(data)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .imgBox{
        width: 100%;
        min-height: 100vh;
        background-color: #0d0c0a;
        position: relative;
        .arrow{
            width: .5rem;
            position: absolute;
            top: 1.7rem;
            left: 50%;
            transform: translateX(-50%);
            animation: slide-in 1.4s ease-in-out 0s infinite;
        }
        .back{
            width: 100%;
        }
        .button{
            width: 56%;
            height: .6rem;
            border-radius: .3rem;
            position: absolute;
            top: 2.1rem;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    @keyframes slide-in {
        0%{
            top: 1.7rem;
        }
        50%{
            top: 1.76rem;
        }
        100%{
            top: 1.7rem;
        }
    }
</style>
